import { useLang } from '../i18n';

const Row = ({ items, hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
        {items.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center">
                <span className={`font-wordmark text-sm sm:text-base tracking-[0.22em] px-6 ${item.startsWith('#PICHONTEAM') ? 'text-crimson' : 'text-ink/80'}`}>
                    {item}
                </span>
                <span className="text-crimson text-xs">*</span>
            </span>
        ))}
    </div>
);

export default function Marquee() {
    const { t, lang } = useLang();
    const items = Array.from({ length: 7 }, (_, i) => t(`mq_${i}`));
    return (
        <div
            className="relative border-y border-ink/10 bg-pastelcream/70 py-4 overflow-hidden"
            data-testid="editorial-marquee"
        >
            <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
                <Row items={items} />
                <Row items={items} hidden />
            </div>
        </div>
    );
}
